import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const olderDeclarationsTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS', 'ADD_EMPTY'], 'OLDER_DECLARATIONS');


export const requestOlderDeclarations = () => {
    return {
        type: olderDeclarationsTypes.REQUEST,
    };
};

export const receiveOlderDeclarations = (response) => {
    return {
        type: olderDeclarationsTypes.RECEIVE,
        data: response,
    };
};

export const receiveOlderDeclarationsError = (response) => {
    return {
        type: olderDeclarationsTypes.ERROR,
        error: response,
    };
};

export const fetchOlderDeclarations = (customerId) => {
    return dispatch => {
        const apiUrl = `/api/v1/contracts/${customerId}/declarations`

        dispatch(requestOlderDeclarations());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveOlderDeclarations(response));
            } catch (e) {
                dispatch(receiveOlderDeclarationsError(response));
            }
        })
        .catch(handleNetworkError);
    };
};